import React from 'react';
import { Objective } from '@/types/objective';
import { motion } from 'framer-motion';

interface ObjectiveDescriptionProps {
  objective: Objective | null;
}

export default function ObjectiveDescription({ objective }: ObjectiveDescriptionProps) {
  if (!objective) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-4 p-4 bg-gray-50 rounded-lg"
    >
      <h3 className="text-lg font-medium text-gray-900 mb-2">{objective.name}</h3>
      <p className="text-gray-600 mb-4">{objective.description}</p>
      <ul className="space-y-2">
        {objective.features.map((feature, index) => (
          <li key={index} className="flex items-center text-gray-600">
            <span className="w-1.5 h-1.5 bg-primary rounded-full mr-2"></span>
            {feature}
          </li>
        ))}
      </ul>
      {objective.addedCost && (
        <p className="mt-4 text-green-600">
          <s>+${objective.addedCost}</s> No added cost for Advanced plans
        </p>
      )}
    </motion.div>
  );
}